import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  HeyLightConfigDTO,
  StripeConfigDTO,
} from "../../NormasTeachingCheckout/PaymentMethodConfiguration.ts";
import { NormasTeachingProductDTO } from "../NormasTeachingProduct/useNormasTeachingProductById.ts";

export function useUpdateNormasTeachingBundle() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);
  const updateNormasTeachingBundle = async (
    normasTeachingBundleId: string,
    normasTeachingBundle: {
      bundleName: string;
      variantBundleName: string;
      priceInCents: {
        amount: number;
        currency: "EUR";
      };
      purchaseAcTags: string[];
      refundAcTags: string[];
      bundleProducts: {
        products: {
          id: string;
          priceInCents: {
            amount: number;
            currency: "EUR";
          };
        }[];
      }[];
      analyticsTag?: string;
      stripeConfig?: StripeConfigDTO;
      heylightConfig?: HeyLightConfigDTO;
      bundleDescription?: string;
      isCouponEnabled?: boolean;
    },
  ): Promise<NormasTeachingProductDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingProductDTO>(
          `/bundles/update/${normasTeachingBundleId}`,
          normasTeachingBundle,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateNormasTeachingBundle,
    loading,
  };
}
